"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const zh_CN_1 = __importDefault(require("ant-design-vue/es/locale/zh_CN"));
const dayjs_1 = __importDefault(require("dayjs"));
require("dayjs/locale/zh-cn");
dayjs_1.default.locale('zh-cn');
exports.default = (0, vue_1.defineComponent)({
    name: 'AntdApp',
    data() {
        return {
            locale: zh_CN_1.default,
        };
    },
});
